import { getApp, getApps, initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

import { environment } from '../environments/environment';

const firebaseApp = getApps().length ? getApp() : initializeApp(environment.firebaseConfig);
const firestore = initializeFirestore(firebaseApp, { experimentalForceLongPolling: true });
const firebaseStorage = getStorage(firebaseApp);

export { firebaseApp, firestore, firebaseStorage };
